import {
  Breadcrumbs as HeroUIBreadcrumbs,
  BreadcrumbsProps as HeroUIBreadcrumbsProps,
} from "@heroui/react";
import { BreadcrumbItem } from "./breadcrumb-item";

export type BreadcrumbsProps = HeroUIBreadcrumbsProps;

export function Breadcrumbs({ children, ...props }: BreadcrumbsProps) {
  return <HeroUIBreadcrumbs {...props}>{children}</HeroUIBreadcrumbs>;
}

Breadcrumbs.displayName = "RecareUI.Breadcrumbs";
Breadcrumbs.Item = BreadcrumbItem;
